export const SELL_REQUEST_IMAGE_SIDES = ['TOP', 'RIGHT', 'BOTTOM', 'LEFT', 'FRONT', 'BACK'] as const
type SellRequestImageSideTuple = typeof SELL_REQUEST_IMAGE_SIDES
type SellRequestImageSide = SellRequestImageSideTuple[number]

export default SellRequestImageSide
